import { NotificationsService } from '../../../Services/shared/notifications.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SelectItem } from 'primeng/api';
import { ArtistProductsService, ArtistProductsSummaryRequest, ArtistProductSummary, ProductsStatusFilters, ProductsStatusFiltersType } from 'src/app/Services/artistproducts.service';
import { Artist, ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { ConnectedArtistSettingRequest, ConnectionsService } from 'src/app/Services/connections.service';
import { SeriesService } from 'src/app/Services/series.service';
import { ImageUrls, NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'view-artist',
    templateUrl: './view-artist.component.html',
    providers: [ArtistProductsService, ArtistsService, ConnectionsService],
    standalone: false
})
export class ViewArtistComponent implements OnInit {
  public defaultImageUrl: string = ImageUrls.IMAGE1;
  public filters: ArtistProductsSummaryRequest = {};
  public artistId!: string;
  items: MenuItem[] | undefined;
  home: MenuItem | undefined;
  public galleryId!: string;
  public artist: Artist | undefined;
  public artistArtTypes: SelectItem[] = [];
  public artistProductsLoaded: boolean = false;
  public artistProducts: ArtistProductSummary[] = [];
  public availableArtworks: number = 0; //setting it in the initial api call (which fetches the available artworks of the artist)
  public authConfig!: AuthConfig;
  public statusFilterOptions: SelectItem[] = [];
  public productCategories: SelectItem[] = [];
  public productSeries: SelectItem[] = [];
  public Queueproducts!: ArtistProductSummary[];
  public requestSent: boolean = false;
  public showArtistOverlayPanel: boolean = false;
  public settingData: ConnectedArtistSettingRequest = { ArtistNotes: null };
  public displayEmojiDialog: boolean = false

  constructor(private artistService: ArtistsService,
    private artistProductsService: ArtistProductsService,
    private authService: AuthService,
    private connectionsService: ConnectionsService,
    private router: Router,
    private seriesService: SeriesService,
    private route: ActivatedRoute,
    private notificationService: NotificationsService,
    private ngxSpinnerService: NgxSpinnerService,
    private transloco: TranslocoService) {
  }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.route.params.subscribe((params) => {
      this.artistId = params['artistId'];

      if ((this.authConfig.IsGallery || this.authConfig.IsGalleryStaff) && this.artistId) {
        this.galleryId = this.authService.getUserId();
        this.getArtistProductsSummaryResponse(this.artistId, this.filters, true);
      }
    });

    if (this.artistId) {
      //get the artist the gallery is viewing
      this.getArtistById(this.artistId);
      this.getArtistArtTypeDropdownItems(this.artistId);
      //this.getAllCategoies();
    }

    this.statusFilterOptions = [];
    this.statusFilterOptions.push({ label: 'Available', value: 'Available' });
    this.statusFilterOptions.push({ label: 'Consigned', value: 'Consigned' });
    this.statusFilterOptions.push({ label: 'Sold', value: 'Sold' });
  }

private getArtistProductsSummaryResponse(artistId: string, filters: ArtistProductsSummaryRequest, isInitialCall: boolean = false): void {
  this.artistProductsLoaded = false;
  this.ngxSpinnerService.show();

  // Ensure filters include pageSize of 1000 while preserving existing filters
  const updatedFilters: ArtistProductsSummaryRequest = {
    ...filters
  };

  // Log filters for debugging
  console.log('Filters sent to API:', updatedFilters);

  this.artistProductsService.getArtistProductsSummaryResponse(artistId, updatedFilters).subscribe(
    (artistProducts: ArtistProductSummary[]) => {
      if (isInitialCall) {
        // Count all products for availableArtworks, regardless of status
        this.availableArtworks = artistProducts.length;
      }

      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var currentDate = new Date();
      this.artistProducts = artistProducts.map(product => ({
        ...product,
        ListedBeforeXDays: product.CreatedDate ? Math.round(Math.abs(((new Date(product.CreatedDate)).getTime() - currentDate.getTime()) / oneDay)) : undefined,
        requestSent: false,
        buttonColorClass: 'p-button-secondary'
      }));

      // Log response for debugging
      console.log('Received artist products:', artistProducts);
      this.artistProductsLoaded = true;
      this.ngxSpinnerService.hide();
    },
    (error) => {
      console.error('Error fetching artist products:', error);
      this.artistProductsLoaded = false;
      this.ngxSpinnerService.hide();
      this.notificationService.showNotification(this.transloco.translate('viewArtist.errorTitle'), this.transloco.translate('viewArtist.failedToLoadProducts'), NotificationTypes.Error);
    }
  );
}
  private getArtistById(artistId: string) {
    this.productCategories = [];
    this.artistService.getArtistById(artistId).subscribe((artist: Artist) => {
        if (!artist) {
            console.error('Artist not found for id:', artistId);
            return;
        }
        this.artist = artist;
        this.items = [
            { label: 'Connected Artists', routerLink: ['/connected-artists'] },
            { label: artist.Name }
        ];
        this.home = { icon: 'pi pi-home', routerLink: '/' };
        this.settingData.ArtistNotes = this.artist.ArtistNotes;
    }, (error) => { console.error(error); });
}

  private getArtistArtTypeDropdownItems(artistId: string) {
    this.artistArtTypes = [];
    this.artistService.getArtistArtTypeDropdownItems(artistId).subscribe((artistArtTypes: SelectItem[]) => {
      this.artistArtTypes = artistArtTypes;
    }, (error) => { console.error(error); });
  }

  public onShowArtistOverlay($event: any) {
    this.showArtistOverlayPanel = true;
  }

  public onArtistOverlayClosed($event: any) {
    this.showArtistOverlayPanel = false;
  }

  public onArtTypedChanged($event: SelectItem) {
    this.filters.ArtTypeId = $event.value;
    if (!this.filters.ArtTypeId) {
      //if no arttype is selected, reset the categories and series bindings alongwith the options
      this.filters.ProductSeriesId = undefined;
      this.productSeries = [];
    } else {
      //if the user has selected the arttype, refresh the categories and series linked with the selected arttype
      this.getAllSeries(this.artistId, this.filters.ArtTypeId);

    }

    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public onStatusFilterChange($event: any) {
    this.filters.Status = $event.value;

    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public clearAllFilters($event: any) {
    this.filters = {};
    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public onGlobalFilterProduct(): void {
    if (this.filters.Query && this.filters.Query.length >= 3) {
      this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
  }


  private getAllSeries(artistId: string, artTypeId: string) {
    this.productSeries = [];
    this.seriesService.getArtistSeriesForGallery(artistId, artTypeId).subscribe((seriesItems) => {
      this.productSeries = seriesItems.map((item) => { return { label: item.Name, value: item.Id } });
    }, (error) => { console.error(error); });
  }

  public onProductSeriesChange($event: SelectItem) {
    this.filters.ProductSeriesId = $event.value;
    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }
  public goToArtworkDetails(selectedProduct: ArtistProductSummary) {
    this.router.navigate([selectedProduct.ArtistId, 'artworks', selectedProduct.Id]);
  }

  public saveConnectedArtistSettings() {
    this.ngxSpinnerService.show();
    this.connectionsService.saveConnectedArtistSettings(this.artistId, this.settingData).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.notificationService.showNotification(this.transloco.translate('viewArtist.successTitle'), this.transloco.translate('viewArtist.changesSaved'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('viewArtist.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public openEmojiDialog() {
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    this.settingData.ArtistNotes = (this.settingData.ArtistNotes || '') + emoji;
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }


  public viewArtistDetails(userName: string) {
    this.router.navigate(['/profile', userName]);
  }
}
